import { render } from "./Roles.vue?vue&type=template&id=e6fb37a2&scoped=true&ts=true"
import script from "./Roles.vue?vue&type=script&lang=ts"
export * from "./Roles.vue?vue&type=script&lang=ts"

import "./Roles.vue?vue&type=style&index=0&id=e6fb37a2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6fb37a2"]])

export default __exports__